import { createApp } from 'vue';
import SearchPage from './App_SearchPage.vue';
import SearchInputBox from './App_SearchInputBox.vue';
import FilterModel from './App_FilterModel.vue';
import Quasar from 'quasar/src/vue-plugin.js';;
import { createPinia } from 'pinia';
import quasarUserOptions from './quasar-user-options';
import MaterialIconSet from 'quasar/icon-set/material-icons';
MaterialIconSet.table.arrowUp = 'arrow_drop_down';

const pinia = createPinia();

const apps = [];

const clickOutsideDirectiveObj = {
  // eslint-disable-next-line no-unused-vars
  mounted(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
};

// Check if #searchPage element exists on the page and mount the corresponding app if it does
if (document.querySelector('#searchPage')) {
  console.log('mounting ---- #searchPage');
  const app = createApp(SearchPage).use(pinia).use(Quasar, quasarUserOptions);
  app.directive('click-outside', clickOutsideDirectiveObj);
  app.mount('#searchPage');
  apps.push(app);
}

// Check if #searchInputBox element exists on the page and mount the corresponding app if it does
if (document.querySelector('#searchInputBox')) {
  console.log('mounting ---- #searchInputBox')
  const app = createApp(SearchInputBox).use(pinia).use(Quasar, quasarUserOptions);
  app.directive('click-outside', clickOutsideDirectiveObj);
  app.mount('#searchInputBox');
  apps.push(app);
}

// Check if #filterModel element exists on the page and mount the corresponding app if it does
if (document.querySelector('#filterModel')) {
  console.log('mounting ---- #filterModel')
  const app = createApp(FilterModel).use(pinia).use(Quasar, quasarUserOptions);
  app.mount('#filterModel');
  apps.push(app);
}
